// Thrown by `getToken` when the SDK reports an interaction-required failure
// (the re-auth class). Consumers catch it and start a login. `authErrorCode`
// is the Auth0 error string (`.error`), not a `.code`.
export class ReauthRequiredError extends Error {
  readonly authErrorCode: string;

  constructor(authErrorCode: string, options?: { cause?: unknown }) {
    super(`Re-authentication required: ${authErrorCode}`, options);
    this.name = 'ReauthRequiredError';
    this.authErrorCode = authErrorCode;
  }
}
